import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CleanerAddress } from '@/hooks/queries/use-get-user-detail.query';

type UserAddressState = {
  userAddress: CleanerAddress | null;
  setUser: (user: CleanerAddress | null) => void;
  clearUser: () => void;
};

export const useUserAddressStore = create<UserAddressState>()(
  devtools(
    set => ({
      userAddress: null,
      setUser: userAddress => set({ userAddress }),
      clearUser: () => set({ userAddress: null }),
    }),
    { name: 'UserAddressStore' }
  )
);
